import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';

export const MainLayout: React.FC = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/admin';

  return (
    <div className="min-h-screen bg-background">
      {!isLoginPage && <Header />}
      <main>
        <Outlet />
      </main>
    </div>
  );
};